export default function PaymentSetupIndicator({ show, kind = 'count' }) {
  if (!show) return null;
  const label = 'Online-Zahlungen noch nicht eingerichtet (optional)';
  return <span aria-label={label} title={label} data-payment-setup-indicator={kind}
    className={kind === 'dot' ? 'inline-block h-2.5 w-2.5 shrink-0 rounded-full bg-[#FF3B30]' : 'ml-2 inline-flex h-5 min-w-[20px] shrink-0 items-center justify-center rounded-full bg-[#FF3B30] px-1.5 text-[11px] font-semibold text-white'}>
    {kind === 'count' ? '1' : null}
  </span>;
}
